"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.normalizeEmbedData = normalizeEmbedData;
exports.hasEmbedDataWidthAndHeight = hasEmbedDataWidthAndHeight;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _style = require("./style");

var IGNORED_TAGS = ['style', 'script']; // Normalize embed data accounting for the "previous" format as well

function normalizeEmbedData() {
  var embedData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var isPreviousEmbedDataFormat = !Array.isArray(embedData) && typeof embedData === 'object' && embedData !== null && Boolean(embedData.type);

  if (isPreviousEmbedDataFormat) {
    // { type: 'iframe', width: 200, height: 300, ...} =>
    // { tag: 'iframe', attributes: [{ key: 'width', value: 200 }, { key: 'height', value: 300 } ]}
    var _embedData$type = embedData.type,
        tag = _embedData$type === void 0 ? 'iframe' : _embedData$type,
        rest = (0, _objectWithoutProperties2.default)(embedData, ["type"]);
    var attributes = Object.keys(rest).map(function (key) {
      return {
        key: key,
        value: rest[key]
      };
    });
    return [{
      tag: tag,
      attributes: attributes
    }];
  }

  return embedData;
}

function hasStyleOrScriptTag(_ref) {
  var tag = _ref.tag;
  return IGNORED_TAGS.includes(tag.toLowerCase());
}

function findHeight(hasHeight, element) {
  return hasHeight || !hasStyleOrScriptTag(element) && (0, _style.hasElementHeight)(element);
} // verifies that the first "visual" element (not "style" or "script" tags)
// of the embed data has height


function hasEmbedDataWidthAndHeight(embedData) {
  return normalizeEmbedData(embedData).reduce(findHeight, false);
}